import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import {
  useIsExternalContactProfileNGAvailable,
  useIsProviderProfileNGAvailable,
  useIsUserProfileNGAvailable,
  useLinkLikeClick,
} from '../../../hooks'
import { getUserProfileRoute } from '../../../utils/user'
import { UserListItem } from '../../ListItem'

import { isNeedToShowUserItemIcons } from './ProfileUsersWidgetItem.utils'
import { ProfileUsersWidgetItemContent } from './ProfileUsersWidgetItemContent'

import * as styles from './ProfileUsersWidgetItem.module.css'

function ProfileUsersWidgetItem({
  Content = ProfileUsersWidgetItemContent,
  blocked,
  className = styles.ProfileUsersWidgetItem,
  hoverClassName = styles.hover,
  isNeedToShowIcons = isNeedToShowUserItemIcons,
  tooltipProps = {
    placement: FLOATING_ELEMENT_PLACEMENT.top,
  },
  value,
  ...restProps
}) {
  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const isExternalContactProfileNGAvailable =
    useIsExternalContactProfileNGAvailable()
  const isProviderProfileNGAvailable = useIsProviderProfileNGAvailable()
  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()

  const link = getUserProfileRoute({
    id: value?.id,
    isExternalContactProfileNGAvailable,
    isProviderProfileNGAvailable,
    isUserProfileNGAvailable,
    role: value?.role,
  })

  function handleClickParticipant(_value, event) {
    handleClick({
      event,
      link,
      // Webapp fallback keeps opening in a new tab; NG profiles navigate in-app.
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  function handleMouseDownParticipant(_value, event) {
    handleMouseDown({ event, link })
  }

  return (
    <UserListItem
      {...restProps}
      Content={Content}
      blocked={blocked}
      className={className}
      hoverClassName={hoverClassName}
      isNeedToShowIcons={isNeedToShowIcons}
      tooltipProps={tooltipProps}
      value={value}
      onClick={handleClickParticipant}
      onMouseDown={handleMouseDownParticipant}
    />
  )
}

export default ProfileUsersWidgetItem
